import descon from "../assets/img/brand/descon-logo.png";
import crbc from "../assets/img/brand/crbc.png";
import cebc from "../assets/img/brand/cebc.png";
import zkb from "../assets/img/brand/zkb.png";
import cscec from "../assets/img/brand/cscec.png";
import hrl from "../assets/img/brand/hrl-logo.png";
import limak from "../assets/img/brand/limak.png";
import albayrak from "../assets/img/brand/albayrak.png";
import paragon from "../assets/img/brand/paragon.png";

export const BRAND_LIST = [
  { id: 1, src: descon, name: "DESCON" },
  { id: 2, src: crbc, name: "CRBC" },
  { id: 3, src: cebc, name: "CEBC Energy China" },
  { id: 4, src: zkb, name: "ZKB Engineering & Construction" },
  { id: 5, src: cscec, name: "CSCEC" },
  { id: 6, src: hrl, name: "Habib Rafiq (Pvt) Ltd." },
  { id: 7, src: limak, name: "Limak" },
  { id: 8, src: albayrak, name: "Albayrak Group" },
  { id: 9, src: paragon, name: "Paragon Developers" },
];
